module.exports = __webpack_public_path__ + "img/datosfacturacion.7888d036.png";